module.exports = __webpack_public_path__ + "assets/img/case3.78fcb9a7.jpg";